import { EmptyState, Page } from "../components/states";
import { useSession } from "../state/session";

/**
 * Ekrany, których zawartość powstanie w kolejnych epikach (E10–E16). Świadomie
 * pokazujemy uczciwy stan pusty z opisem, co się tu pojawi — zamiast atrapy danych,
 * która sugerowałaby działającą funkcję.
 */

export function Contracts() {
  const { t } = useSession().translator;
  return (
    <Page title={t("nav.contracts")}>
      <EmptyState title={t("documents.empty")} description={t("documents.upload")} />
    </Page>
  );
}

export function Documents() {
  const { t } = useSession().translator;
  return (
    <Page title={t("documents.title")}>
      <EmptyState title={t("documents.empty")} description={t("documents.upload")} />
    </Page>
  );
}

export function Timeline() {
  const { t } = useSession().translator;
  return (
    <Page title={t("nav.timeline")}>
      <EmptyState title={t("today.nothingToDo")} />
    </Page>
  );
}

export function Ask() {
  const { t } = useSession().translator;
  return (
    <Page title={t("ask.title")} lead={t("ask.placeholder")}>
      <EmptyState title={t("ask.title")} description={t("ask.placeholder")} />
      {/* Zastrzeżenie prawne towarzyszy asystentowi zawsze, nie tylko przy odpowiedzi (§40). */}
      <p className="ai-notice">{t("ask.disclaimer")}</p>
    </Page>
  );
}

export function Connections() {
  const { t } = useSession().translator;
  return (
    <Page title={t("connections.title")} lead={t("connections.description")}>
      <EmptyState title={t("connections.title")} description={t("connections.connect")} />
    </Page>
  );
}

export function Company() {
  const { organization, translator } = useSession();
  const { t } = translator;
  return (
    <Page title={t("nav.company")} lead={organization?.name}>
      <EmptyState title={t("onboarding.nip.title")} description={t("onboarding.nip.description")} />
    </Page>
  );
}

export function Settings() {
  const { user, translator } = useSession();
  const { t } = translator;
  return (
    <Page title={t("nav.settings")} lead={user?.email ?? undefined}>
      <EmptyState title={t("nav.settings")} description={t("ask.aiNotice")} />
    </Page>
  );
}
